export const hasHttpOrHttps = (item: string): boolean =>
  /^https?:\/\//.test(item);
